export default __webpack_public_path__ + "static/media/49-min.5c94a438.jpg";